import React from "react";
import styles from "./styles.module.scss";
import useMccStore from "../../../../stores/mcc";
import CrossIcon from '../../../../assets/svg/icons/common/CrossIcon';
import ConfirmationModal from "../../../application/components/ConfirmationModal/ConfirmationModal";
import { mccBulkRemove } from "../../../../../api";
import toast from "react-hot-toast";
import ProcessorUpdate from "./processor";
import AddendumUpdate from "./addendum";
import RemoveProcessorUpdate from "./remove-processor";
import RemoveAddendumUpdate from "./remove-addendum";

const BulkAction = ({ fetchData }) => {

  const selectedMcc = useMccStore((state) => state.selectedMcc);
  const setSelectedMcc = useMccStore((state) => state.setSelectedMcc);
  const bulkDeleteModal = useMccStore((state) => state.bulkDeleteModal);
  const setBulkDeleteModal = useMccStore((state) => state.setBulkDeleteModal);
  const bulkProcessorModal = useMccStore((state) => state.bulkProcessorModal);
  const setBulkProcessorModal = useMccStore((state) => state.setBulkProcessorModal);
  const bulkAddendumsModal = useMccStore((state) => state.bulkAddendumsModal);
  const setBulkAddendumsModal = useMccStore((state) => state.setBulkAddendumsModal);
  const bulkRemoveProcessorModal = useMccStore((state) => state.bulkRemoveProcessorModal);
  const setBulkRemoveProcessorModal = useMccStore((state) => state.setBulkRemoveProcessorModal);
  const bulkRemoveAddendumsModal = useMccStore((state) => state.bulkRemoveAddendumsModal);
  const setBulkRemoveAddendumsModal = useMccStore((state) => state.setBulkRemoveAddendumsModal);

  const deleteMcc = async () => {
    const toastId = toast.loading('Deleting...');
    let data = {
      mcc: selectedMcc
    }
    const response = await mccBulkRemove(data);
    if (response?.success) {
      toast.success('Deleted successfully', { id: toastId, duration: 5000 });
      setSelectedMcc([]);
      setBulkDeleteModal(false);
      fetchData();
    }
    else {
      toast.error('Failed to delete MCC codes', { id: toastId, duration: 5000 });
      setBulkDeleteModal(false);
    }
  };


  return (
    <>
      <div className={styles.bulkActionsWrapper}>
        <p className={styles.label}>{selectedMcc?.length} Selected</p>
        <div className={styles.actionsScroll}>
          <button
            className={styles.actionButton}
            onClick={() => setBulkProcessorModal(true)}
          >
            Add Processors
          </button>
          <button
            className={styles.actionButton}
            onClick={() => setBulkRemoveProcessorModal(true)}
          >
            Remove Processors
          </button>
          <button
            className={styles.actionButton}
            onClick={() => setBulkAddendumsModal(true)}
          >
            Add Addendums
          </button>
          <button
            className={styles.actionButton}
            onClick={() => setBulkRemoveAddendumsModal(true)}
          >
            Remove Addendums
          </button>
          <button
            className={styles.actionButton}
            onClick={() => setBulkDeleteModal(true)}
          >
            Delete Code
          </button>
          <button
            className={styles.actionButton}
            onClick={() => setSelectedMcc([])}
          >
            <CrossIcon />
          </button>
        </div>
      </div>

      {bulkDeleteModal && (
        <ConfirmationModal
          open={bulkDeleteModal}
          onClose={() => {
            setBulkDeleteModal(false);
          }}
          message={
            "Are you sure you want to delete selected codes? You can’t undo this action."
          }
          onConfirmClick={deleteMcc}
          submitButtonText={`Delete ${selectedMcc?.length} codes`}
        />
      )}

      <ProcessorUpdate
        isOpen={bulkProcessorModal}
        onClose={() => {
          setBulkProcessorModal(false);
        }}
        fetchData={fetchData}
      />

      <AddendumUpdate
        isOpen={bulkAddendumsModal}
        onClose={() => {
          setBulkAddendumsModal(false);
        }}
        fetchData={fetchData}
      />

      <RemoveProcessorUpdate
        isOpen={bulkRemoveProcessorModal}
        onClose={() => {
          setBulkRemoveProcessorModal(false);
        }}
        fetchData={fetchData}
      />

      <RemoveAddendumUpdate
        isOpen={bulkRemoveAddendumsModal}
        onClose={() => {
          setBulkRemoveAddendumsModal(false);
        }}
        fetchData={fetchData}
      />
    </>
  );
};

export default BulkAction;
